/* global femcare */

femcare.askExpert.questions = {
    init: function () {
        this.category = '';
        this.pageIndex = 1;

        if ($('.questions').length) {
            this.initLoadMoreButton();
        }
    },

    /**
     * Init load more articles after clicking load-more button event using event delegation.
     */
    initLoadMoreButton() {
    $('.questions').on('click', '.questions__load-more', (e) => {
        e.preventDefault();

        const $container = $(e.target).parent().find('.questions__list');
        const $form = $('.questions form');
        const hits = $('.questions form input[name=hits]').val();
        const offset = this.pageIndex * hits;
        const $numberOfArticlesStatus = $('.questions__status');
        const labelStatus = $numberOfArticlesStatus.data('label-status');
        let categoryString = '';

        const $loadMoreButton = $(e.target);
        $loadMoreButton.prop('disabled', true).addClass('btn-loading');

        if (this.category) {
            categoryString = `&category=${encodeURIComponent(this.category)}`;
        }

        $.ajax({
            type: 'GET',
            data: $form.serialize(),
            url: `${$form.attr('action')}?offset=${offset}${categoryString}`,
            success: (data) => {
                $loadMoreButton.remove(); // remove old button

                const articles = $(data).find('.questions__list').children();
                const loadMoreButton = $(data).find('.questions__load-more');

                if (articles.length) {
                    $container.append(articles);
                    $container.after(loadMoreButton);

                    // Accessibility - update the status of loaded questions
                    const totalArticles = $container.children('li').length;
                    $numberOfArticlesStatus.text(`${totalArticles} ${labelStatus}`);

                    // Accessibility - focus first new item
                    const firstNewArticle = articles.first();
                    const firstFocusableElement = firstNewArticle.find('.question__link, [tabindex]:not([tabindex="-1"])').first();

                    if (firstFocusableElement.length) {
                        firstFocusableElement[0].focus();
                    }
                }

                this.pageIndex++;
            },
            complete: () => {
                $loadMoreButton.prop('disabled', false).removeClass('btn-loading');
            }
        });
    });
}
};
